import BaseEntity from '../BaseEntity.model';
import { Progress } from './Progress.model';

export default interface IStrength extends BaseEntity {
    Name: string;
    Progress: Progress[];
    UpdatedAt: string;
    FactorAndRiskAssessmentId: string;
    CreatedAt: string;
}

export class Strength implements IStrength {
    Id: string | null;
    Name: string;
    Progress: Progress[];
    UpdatedAt: string;
    FactorAndRiskAssessmentId: string;
    CreatedAt: string;

    IsSelected: boolean;
    IsOpenProgress: boolean;
    NewProgressNote: string;

    constructor() {
        this.Id = null;
        this.Name = '';
        this.UpdatedAt = '';
        this.FactorAndRiskAssessmentId = '';
        this.CreatedAt = '';

        this.IsSelected = false;
        this.IsOpenProgress = false;
        this.NewProgressNote = '';
    }
}
